<template>
  <base-modal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :size="'md'"
    :is-editable="false"
    :is-archivable="false"
  >
    <template #header>
      {{ $t('buttons.acceptInvoice') }}
    </template>
    <template #body>
      <form @submit.prevent="acceptInvoice">
        <b-row>
          <b-col>
            <b-form-group>
              <label
                for="sell_date"
                class="form-control-label">
                {{ $t('views.exsbinvoices.list.issueDate') }}
              </label>
              <el-date-picker
                :picker-options="{firstDayOfWeek: 1}"
                id="sell_date"
                v-model="issueDate"
                type="date"
                :placeholder="$t('views.exsbinvoices.list.issueDate')"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label
                for="sell_date"
                class="form-control-label">
                {{ $t('views.exsbinvoices.list.sellDate') }}
              </label>
              <el-date-picker
                :picker-options="{firstDayOfWeek: 1}"
                id="sell_date"
                v-model="sellDate"
                type="date"
                :placeholder="$t('views.exsbinvoices.list.sellDate')"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </b-form-group>
          </b-col>
        </b-row>
        <button
          type="button"
          class="btn btn-warning"
          @click="acceptInvoice()"
        >
          {{ $t('buttons.acceptInvoice') }}
        </button>
      </form>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'InvoiceAcceptModal',
  props: ['id', 'selections'],
  data () {
    return {
      sellDate: this.$moment().format('YYYY-MM-DD'),
      issueDate: this.$moment().format('YYYY-MM-DD')
    }
  },

  components: {
    BaseModal
  },

  computed: {
    ...mapGetters({
      isVisible: 'exsbinvoice/acceptModal/isVisible'
    })
  },

  methods: {
    acceptInvoice () {
      this.$Swal({
        title: this.$t('notifications.invoice.acceptTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(() => {
        if (this.selections && this.selections.length > 0) {
          this.putSelectedInvoicesAccepted().then(response => {
            if (response) {
              this.hideModal()
              this.$emit('reload')
            }
          })
        } else {
          this.putInvoiceAccepted().then(response => {
            if (response) {
              this.hideModal()
              this.retrieve(decodeURIComponent(this.$route.params.id))
            }
          })
        }
      })
    },

    putInvoiceAccepted () {
      let data = { sellDate: this.sellDate, issueDate: this.issueDate }
      return new ApiService(`e_x_s_b_invoices/${getId(this.$route.params.id)}/accept`).put(data)
    },
    putSelectedInvoicesAccepted () {
      let data = { sellDate: this.sellDate, issueDate: this.issueDate, selections: this.selections.map(entry => { return getId(entry['@id']) }) }
      return new ApiService(`e_x_s_b_invoices/acceptselectedinvoices`).post(data)
    },
    hideModal () {
      this.toggleModal()
    },

    ...mapMutations({
      toggleModal: 'exsbinvoice/acceptModal/toggleModal'
    }),

    ...mapActions({
      retrieve: 'exsbinvoice/show/retrieve'
    })
  }
}
</script>

<style scoped>

</style>
